export const modalName = {
  modalEditMentor: 1
};
